const PageNotFoundStyles = {
  mainContainer: {
    backgroundColor: "white",
    width: "100vw",
    height: "100vh",
  },
} as const;

export default PageNotFoundStyles;
